import { ErrorMessage } from 'formik';

import styles from '../sign-up-form.module.css';

export function FieldError({ name, t }) {
	return (
		<ErrorMessage name={name}>
			{id => <span className={styles.errorText}>{t(id)}</span>}
		</ErrorMessage>
	);
}
